import { setCookies } from "cookies-next";
import { TIME_COOKIES } from "lib/config/global";
import { store } from "lib/store";
import { memberActionTypes } from "lib/store/member/reducer";
import client from "../client";

interface Request {
  prefix: string;
  username: string;
  password: string;
  tel: string;
  currency_id: number;
  ref_id?: string;
  ref_redirect?: string | null;
  token: string;
  otp: string;
  full_name: string;
  bank_type_id: number;
  bank_name: string;
  bank_number: string;
}

export interface RegisterResponse {
  access_token?: string;
  refresh_token?: string;
}

export default function API(request: Request): Promise<RegisterResponse> {
  return client
    .post(`members/register_on_website_full_chain`, request)
    .then((response) => response.data)
    .then((json: RegisterResponse) => {
      setCookies("access_token", json.access_token, { maxAge: TIME_COOKIES });
      setCookies("refresh_token", json.refresh_token, { maxAge: TIME_COOKIES });
      localStorage.setItem("access_token", json.access_token ?? "");
      store.dispatch({
        type: memberActionTypes.ACTION_USER_LOGIN,
        payload: json,
      });
      return json;
    });
}
